module.exports = __webpack_public_path__ + "static/media/320x100_0008_en.74bd31d8.jpg";